import React from "react"

interface LineVerticalProps {
  rotate?: boolean // rotate는 선택적 boolean props
}

const LineVertical: React.FC<LineVerticalProps> = ({ rotate = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="140"
      viewBox="0 0 26 140"
      fill="none"
      style={{
        transform: rotate ? "rotate(180deg)" : "none",
      }}
    >
      <path
        d="M11.25 138C11.25 138.966 12.0335 139.75 13 139.75C13.9665 139.75 14.75 138.966 14.75 138H11.25ZM14.2374 0.762573C13.554 0.0791473 12.446 0.0791473 11.7626 0.762573L0.625631 11.8995C-0.057786 12.5829 -0.057786 13.691 0.625631 14.3744C1.30905 15.0578 2.41709 15.0578 3.1005 14.3744L13 4.47488L22.8995 14.3744C23.5829 15.0578 24.691 15.0578 25.3744 14.3744C26.0578 13.691 26.0578 12.5829 25.3744 11.8995L14.2374 0.762573ZM14.75 138L14.75 2H11.25L11.25 138H14.75Z"
        fill="#4282EF"
      />
    </svg>
  )
}

export default LineVertical
